import { render, staticRenderFns } from "./ResponseComposer.vue?vue&type=template&id=c877726e&"
import script from "./ResponseComposer.vue?vue&type=script&lang=js&"
export * from "./ResponseComposer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports